<mac-form-input-text [type]="passwordVisible ? 'text' : 'password'" [suffix]="suffixTemplate"
  [formControl]="formControl" [label]="label" [placeholder]="placeholder"></mac-form-input-text>
<ng-template #suffixTemplate>
  <mac-icon [icon]="passwordVisible ? 'visibility_off' : 'visibility'" style="cursor: pointer;"
    (click)="passwordVisible = !passwordVisible"></mac-icon>
</ng-template>